module.exports = {
  "country": "EE",
  "artist": "Elina Nersajeva",
  "song": "La Forza",
  "year": "2018",
  "place": "8",
  "spotify": ""
};